"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_select_1 = require("react-select");
const keautils_1 = require("keautils");
const keautils_2 = require("keautils");
const moize_1 = require("moize");
const keautils_3 = require("keautils");
const formField_1 = require("../fields/formField");
const text_1 = require("../fields/text");
const keautils_4 = require("keautils");
const index_1 = require("../botones/index");
/**Un elemento del selector que indica que hay mas elementos en la lista que no se estan mostrando */
const selectorMaxValue = Symbol("SelectorMaxValue");
function mapValue(value) {
    if (value == null) {
        throw new Error("No se puede mapear el valor null o undefined de un elemento del selector");
    }
    if (value == 0)
        return "__NUMBERZERO__";
    else if (typeof (value) == "string") {
        return "_STR_" + value;
    }
    else if (typeof (value) == "number") {
        return "_NUM_" + value;
    }
    else if (typeof (value) == 'boolean') {
        return "__BOOLEAN__" + value;
    }
    else if (value instanceof Date) {
        return "__DATE__" + value.toISOString();
    }
    else if (typeof (value) === "symbol" || value instanceof Symbol) {
        if (value == selectorMaxValue) {
            return "__SELECTOR_MAX_VALUE_";
        }
        else {
            throw new Error("Symbol value not valid");
        }
    }
    else {
        return keautils_4.assertUnreachable(value);
    }
}
function unmapValue(value) {
    if (typeof (value) != "string") {
        throw new Error("Unmap value nunca debe de tener un valor que no sea string");
    }
    if (value === "__SELECTOR_MAX_VALUE_") {
        throw new Error("El elemento SELECTOR_MAX_VALUE no debe de estar habilitado");
    }
    if (value === "__BOOLEAN__" + true)
        return true;
    else if (value === "__BOOLEAN__" + false)
        return false;
    else if (value === "__NUMBERZERO__")
        return 0;
    else if (value.startsWith("__DATE__")) {
        const part = value.substr("__DATE__".length);
        return new Date(part);
    }
    else if (value.startsWith("_STR_")) {
        return value.substr("_STR_".length);
    }
    else if (value.startsWith("_NUM_")) {
        return Number.parseFloat(value.substr("_NUM_".length));
    }
    else {
        throw new Error(`El valor del selector ${value} no es válido para la función unmapValue`);
    }
}
/**Función que no filtra los elementos de react select segun el filtro de texto, pero que si quita los elementos seleccionados de un multiselector del resultado de las opciones */
function reactSelectDisabledFilterOptions(options, filter, currentValues) {
    options = options || [];
    const ret = [];
    for (const option of options) {
        if (!currentValues || !keautils_2.contains(currentValues, option)) {
            ret.push(option);
        }
    }
    return ret;
}
/**Función que filtra los elementos de react select utilizando la función de busqueda de texto */
function reactSelectFilterOptions(options, filter, currentValues) {
    options = options || [];
    const maxCount = 200;
    const ret = [];
    let cantElementosEscaneados = 0;
    for (const option of options) {
        cantElementosEscaneados++;
        if (keautils_1.search(filter, option.label)) {
            //Quitamos los valores que ya estan en currentValues, segun la documentación de kea-react
            if (!currentValues || !keautils_2.contains(currentValues, option)) {
                ret.push(option);
                //Como maximo ponemos maxCount elementos
                if (ret.length == maxCount && cantElementosEscaneados < (options.length - 50)) {
                    break;
                }
            }
        }
    }
    //Calculamos un estimado de la cantidad de elementos que no se estan mostrando:
    if (cantElementosEscaneados < options.length) {
        const factorFiltro = ret.length / cantElementosEscaneados;
        const missingElementCount = Math.max(10, Math.ceil((options.length - maxCount) * factorFiltro));
        ret.push({ label: "" + missingElementCount + " elementos mas aprox.", value: mapValue(selectorMaxValue) });
    }
    return ret;
}
const reactSelectFix = {
    menuContainerStyle: { 'zIndex': 999 },
};
function mapItem(x) {
    const props = {
        label: "" + x.label,
        className: x.style ? "alert-" + x.style : undefined,
        view: x.view,
    };
    if (x.disabled) {
        return Object.assign({}, props, { disabled: true });
    }
    else {
        return Object.assign({}, props, { value: mapValue(x.value) });
    }
}
/**Función que dibuja los elementos del react select */
function optionRenderer(x) {
    if (x.view) {
        return x.view;
    }
    else {
        return React.createElement("span", null, x.label);
    }
}
/**Vista de un react-select */
class ReactSelectViewNoRx extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.last = {};
        this.filterOptionsMemoize = moize_1.default(reactSelectFilterOptions);
        this.filterOptionsDisabledMemoize = moize_1.default(reactSelectDisabledFilterOptions);
        this.filterOptions = (a, b, c) => this.filterOptionsMemoize(a, b, c);
        this.filterOptionsDisabled = (options, filter, currentValues) => this.filterOptionsDisabledMemoize(options, "", currentValues);
        this.handleOnChange = (option) => {
            const props = this.props;
            if (props.multi) {
                const onChange = props.onChange;
                if (onChange) {
                    const value = option.map(x => x.value).map(x => unmapValue(x));
                    onChange(value);
                }
            }
            else {
                const onChange = props.onChange;
                if (onChange) {
                    const value = option && unmapValue(option.value);
                    onChange(value);
                }
            }
        };
        this.items = (props) => props.items;
        this.value = (props) => props.value;
        this.multi = (props) => props.multi;
        this.selectedText = keautils_3.createSelector(this.items, this.value, (items, value) => {
            return (items || []).filter(x => x.value == value).map(x => "" + x.label)[0] || "";
        });
        this.mappedItems = keautils_3.createSelector(this.items, items => {
            return items ? items.map(mapItem) : [];
        });
        this.mappedValue = keautils_3.createSelector(this.value, this.mappedItems, this.multi, (value, options, multi) => {
            if (value == null) {
                return multi ? [] : undefined;
            }
            else if (keautils_2.isArray(value)) {
                return keautils_2.mapKeys(value.map(x => mapValue(x)), options, x => x.value);
            }
            else {
                return mapValue(value);
            }
        });
        this.onBorrar = async () => {
            if (this.props.onBorrar && this.props.value) {
                await this.props.onBorrar(this.props.value);
            }
        };
        this.onEditar = async () => {
            if (this.props.onEditar && this.props.value) {
                await this.props.onEditar(this.props.value);
            }
        };
    }
    render() {
        const { items, loading, value, onChange, readonly, multi } = this.props;
        const selectedText = this.selectedText(this.props);
        const options = this.mappedItems(this.props);
        const mappedValue = this.mappedValue(this.props);
        const anySelected = value == null ? false : keautils_2.isArray(value) ? value.length > 0 : true;
        return (React.createElement(formField_1.FormField, { label: this.props.label, error: this.props.error },
            React.createElement("div", { style: { display: "flex", alignItems: "center" } },
                React.createElement("div", { style: { flex: "1 1 auto" } }, this.props.readonly ? React.createElement(text_1.Text, { value: selectedText, readonly: true }) :
                    React.createElement(react_select_1.default, Object.assign({ placeholder: "Seleccionar...", noResultsText: "No hay resultados.", options: options, isLoading: loading, value: mappedValue, onChange: this.handleOnChange, multi: this.props.multi, optionRenderer: optionRenderer }, reactSelectFix, { filterOptions: this.props.disableFiltering ? this.filterOptionsDisabled : this.filterOptions, onInputChange: this.props.onInputChange, onInputKeyDown: this.props.onInputKeyDown }))),
                this.props.onBorrar && !this.props.readonly &&
                    React.createElement("div", { style: { flex: "0 0 auto" } },
                        React.createElement(index_1.Button, { onClick: this.onBorrar, iconClass: "fa fa-trash-o fa-fw", style: "danger", tooltip: "Borrar", disabled: !anySelected })),
                this.props.onEditar && !this.props.readonly &&
                    React.createElement("div", { style: { flex: "0 0 auto" } },
                        React.createElement(index_1.Button, { onClick: this.onEditar, iconClass: "fa fa-pencil fa-fw", style: "primary", tooltip: "Editar", disabled: !anySelected })),
                this.props.onAgregar && !this.props.readonly &&
                    React.createElement("div", { style: { flex: "0 0 auto" } },
                        React.createElement(index_1.Button, { onClick: this.props.onAgregar, iconClass: "fa fa-plus fa-fw", style: "primary", tooltip: "Agregar" })))));
    }
}
exports.ReactSelectViewNoRx = ReactSelectViewNoRx;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/selector/view.js
// module id = 2254
// module chunks = 0